import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import CommonModal from '../Modals/common'
import './styles.scss'

class AccountInformation extends Component {
  constructor() {
    super()
    this.state = {
      deleteAccount: false
    }
    this.deleteAccount = this.deleteAccount.bind(this)
    this.closeDelete = this.closeDelete.bind(this)
    this.handleChangeTemp = this.handleChangeTemp.bind(this)
  }

  componentWillMount() {
    const tempType = localStorage.getItem('temperatureType') === 'F' ? true : false
    this.setState({ temperatureType: tempType })
  }

  componentWillReceiveProps(np) {
    const { deleteAccountConfirmation, signOut, history, resetCozy } = np
    // Redirect to login on account delete confirmation
    if (deleteAccountConfirmation && deleteAccountConfirmation.data && deleteAccountConfirmation.data.deleteAccount) {
      this.setState({ deleteAccount: false }, () => {
        signOut()
        resetCozy()
        history.push('/login')
      })
    }
  }

  onSignOutClick() {
    const { signOut, history, resetCozy } = this.props
    signOut()
    resetCozy()
    history.push('/login')
  }

  handleDeleteModal() {
    this.setState({ deleteAccount: true })
  }

  deleteAccount() {
    this.props.deleteAccount()
  }

  closeDelete() {
    // handle operation on popup close
    this.setState({ deleteAccount: false })
  }

  handleChangeTemp(event) {
    // Save the conversion i.e. F and C to the local storage
    !event.target.checked ? localStorage.setItem('temperatureType', 'F') : localStorage.setItem('temperatureType', 'C')
    this.props.fetchRooms()
  }

  render() {
    return (
      <div>
        <main id="AccountInformation">
          <div className="wrapper">
            <header className="header display-flex">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h3 className="secondary-title">Account Information</h3>
                    <div className="close">
                      <Link to="/home" data-dismiss="modal">
                        <img alt="" src="/img/close-icon.png" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </header>
            <CommonModal
              key="deleteAccount"
              modalType="deleteAccount"
              open={this.state.deleteAccount}
              {...this.props}
              closeModal={this.deleteAccount}
              closeDelete={this.closeDelete}
            />
            <div className="container-inner">
              <label className="switch account-toggle">
                <input className="switch-input" type="checkbox" defaultChecked={!this.state.temperatureType} onChange={this.handleChangeTemp}/>
                <span className="switch-label" data-on="&#176;C" data-off="&#176;F"></span> <span className="switch-handle"></span> 
              </label>
              <div className="account-list-box">
                <ul className="list-group list-group-flush">
                  <li className="list-group-item d-flex align-items-center justify-content-between">
                    <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                      <Link className="d-flex" to={'/home'}>
                        <div className="home-icon">
                          <img alt="" src="img/account_home.svg" />
                        </div>
                        <h5>Home</h5>
                      </Link>
                    </div>
                  </li>
                  {/*<li className="list-group-item d-flex align-items-center justify-content-between">
                    <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                      <Link className="d-flex" to={'/edit-room'}>
                        <div className="edit-room">
                          <img alt="" src="img/edit_room.svg" />
                        </div>
                        <h5>Edit Rooms</h5>
                      </Link>
                    </div>
                  </li>*/}
                  <li className="list-group-item d-flex align-items-center justify-content-between">
                    <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                      <a className="d-flex" rel="noopener noreferrer" target="_blank" href="https://radiatorlabs.zendesk.com/hc/en-us/requests/new">
                        <div className="help-icon">
                          <img alt="" src="img/help_icon.svg" />
                        </div>
                        <h5>Help</h5>
                      </a>
                    </div>
                  </li>
                  <li className="list-group-item d-flex align-items-center justify-content-between">
                    <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                      <a
                        className="d-flex"
                        rel="noopener noreferrer"
                        target="_blank"
                        href="https://radiatorlabs.zendesk.com/hc/en-us/sections/204004367-FAQ-s"
                      >
                        <div className="faq-icon">
                          <img alt="" src="img/faq_icon.svg" />
                        </div>
                        <h5>FAQ’s</h5>
                      </a>
                    </div>
                  </li>
                  <li className="list-group-item d-flex align-items-center justify-content-between">
                    <Link to={'/'} className="d-flex" onClick={() => this.onSignOutClick()}>
                      <div className="list-left-icon align-middle d-flex align-items-center justify-content-start">
                        <div className="sign-out">
                          <img alt="" src="img/sign_out.svg" />
                        </div>
                        <h5>Sign Out</h5>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <footer>
              <div className="container">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <div className="footer-inner">
                      <div onClick={this.handleDeleteModal.bind(this)} className="delete-text">
                        <img alt="" src="/img/trash.svg" />
                        Delete Account
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </footer>
          </div>
        </main>
      </div>
    )
  }
}
export default AccountInformation



// WEBPACK FOOTER //
// ./src/views/AccountInformation/component.js